import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import {
  CreateEventCategoryDto,
  PublicEventCategory,
} from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const createEventCategory = async ({
  orgId,
  eventCategory,
}: {
  orgId: string;
  eventCategory: CreateEventCategoryDto;
}): Promise<PublicEventCategory> => {
  const response = await axiosClient.post(
    `/${orgId}/event-categories`,
    eventCategory,
  );
  return response.data;
};

export function useCreateEventCategory(
  queryOptions?: UseMutationOptions<
    PublicEventCategory,
    HttpError,
    { orgId: string; eventCategory: CreateEventCategoryDto }
  >,
) {
  return useMutation({
    mutationFn: ({ orgId, eventCategory }) =>
      createEventCategory({
        orgId,
        eventCategory,
      }),
    ...queryOptions,
  });
}
